module.exports = __webpack_public_path__ + "img/pinfl__ru__id_doc.6e1a3d49.png";